// extracted by mini-css-extract-plugin
module.exports = {"multiSelection":"MultiSelection_multiSelection__X_Cpy","blockHoverStates":"MultiSelection_blockHoverStates__kLhig"};